import React from 'react'
import '../css/all.css';
import Work from "../assests/work.png";
export default function Experience() {
    return (
        <div className="exp container pt-5">
            <div className="row align-items-center">
             <div className="col  align-items-center">
                 
                 <div className="col  align-items-center name">
                            <h3 className="mb-4" >Experience</h3>
                            <img alt="pic" src={Work} className="mx-auto mr-5"></img>   <h2 className="work">Intech Olympiad Maharashtra</h2>
                            <p className="tagline mt-2">The very nature of the competition help me to acquire "Learning to Learn" skill, which is important for survival in this industrial world. </p>
                            <br></br>
                            <img alt="pic" src={Work} className="mx-auto mr-5"></img>   <h2 className="work">Intern At Edify</h2>
                            <p className="tagline mt-2">Web development intern at Edify. </p>
                            <br></br>
                            <img alt="pic" src={Work} className="mx-auto mr-5"></img>   <h2 className="work">3 Paid Projects</h2>
                            <p className="tagline mt-2">3 full stack projects for clients.</p>
                            

                 </div>
             </div>
             </div>
              
        </div>
    )
}
